import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import Timeformat from "../../utils/Timeformat";

class MachinesOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            requestedCompanyMachines: null,
            filteredCompanyMachines: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanyMachines = this.requestCompanyMachines.bind(this);
        this.requestChangeMachineHide = this.requestChangeMachineHide.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentWillMount() {

        this.requestCompanyMachines();

    }

    requestCompanyMachines() {

        const params = {
            action: 'getCompanyMachines',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.state.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    requestedCompanyMachines: res,
                    filteredCompanyMachines: this.getTableData(res),
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    requestChangeMachineHide(row) {

        if (!(row && row.machine_id && row.hide_machine)) return null;

        const params = {
            action: 'changeCompanyMachineHide',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            machineId: row.machine_id,
            companyId: row.id_company,
            hideMachine: row.hide_machine
        };

        const callback = function(res) {
            if (res) {
                if (res.success) this.requestCompanyMachines();
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    onSearch(name, value) {

        const tableData = this.getTableData(this.state.requestedCompanyMachines);
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value);

        this.setState({
            filteredCompanyMachines: filteredData
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyMachines: this.getTableData(this.state.requestedCompanyMachines),
        });

    }

    editRow(row) {

        this.changeView('edit', row);

    }

    changeView(view, editRow = null) {

        if (this.props.changeView) this.props.changeView(view, editRow);

    }

    getTableData(rawData) {

        rawData = (rawData) ? rawData : this.state.currentCompanies;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const labelYes = this.translate('yes');
        const labelNo = this.translate('no');
        const rows = [];

        for (let i = 0; i < rawData.length; i++) {
            let rowTemp = rawData[i];
            let lastSeen = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';
            let lastTransmission = (rowTemp.last_seen) ? Timeformat.fromUnix(rowTemp.last_seen).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rowTemp.lastSeen = lastSeen;
            rowTemp.lastTransmission = lastTransmission;
            rowTemp.hideMachine = (rowTemp.hide_machine && rowTemp.hide_machine === 'Y') ? labelYes : labelNo;

            rows.push(rowTemp);

            /*rows.push({
                machine_id: rowTemp.machine_id,
                machine_name: rowTemp.machine_name,
                heads: rowTemp.heads,
                needles: rowTemp.needles,
                location_name: rowTemp.location_name,
                id_datacollector: rowTemp.id_datacollector,
                lastSeen: lastSeen,
                lastTransmission: lastTransmission,
                hide_machine: rowTemp.hide_machine,
                hideMachine: (rowTemp.hide_machine && rowTemp.hide_machine === 'Y') ? labelYes : labelNo
            });*/
        }

        return rows;

    }

    getTableColumns() {

        return [
            {
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },
            {
                key: 'locationName',
                nameKey: 'location',
                sortType: 'string',
            },
            {
                key: 'order',
                nameKey: 'order',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'heads',
                nameKey: 'heads',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'needles',
                nameKey: 'needles',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'dataCollectorId',
                nameKey: 'dataCollector',
                sortType: 'string',
            },
            {
                key: 'lastSeen',
                nameKey: 'lastSeen',
                classes: 'text-right',
                sortType: 'date',
            },
            {
                key: 'lastTransmission',
                nameKey: 'lastTransmission',
                classes: 'text-right',
                sortType: 'date',
            },
            {
                key: 'hideMachine',
                nameKey: 'hideMachine',
                sortType: 'string',
            },
            {
                key: 'options',
                nameKey: 'options',
            },
        ];

    }

    getTableRows() {

        const data = (this.state.filteredCompanyMachines) ? this.state.filteredCompanyMachines : [];
        const labelFadeIn = this.translate('fadeIn');
        const labelFadeOut = this.translate('fadeOut');
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            const rowTemp = data[i];
            const toggleClass = (rowTemp.hide_machine === 'N') ? 'optionGreen' : 'optionRed';

            rows.push({
                machineId: rowTemp.machine_id,
                machineName: rowTemp.machine_name,
                heads: (rowTemp.heads_manually_overwritten !== null) ? rowTemp.heads_manually_overwritten : rowTemp.heads,
                needles: rowTemp.needles,
                locationName: rowTemp.location_name,
                order: rowTemp.machine_order,
                dataCollectorId: rowTemp.id_datacollector,
                lastSeen: rowTemp.lastSeen,
                lastTransmission: rowTemp.lastTransmission,
                hideMachine: rowTemp.hideMachine,
                options: <div className="tableOptions">
                    <a className="optionEdit" onClick={() => this.editRow(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                    <a className={toggleClass} onClick={() => this.requestChangeMachineHide(rowTemp)} title={(rowTemp.hide_machine && rowTemp.hide_machine === 'Y') ? labelFadeIn : labelFadeOut}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (this.state.requestedCompanyMachines === null) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredCompanyMachines) ? this.state.filteredCompanyMachines.length : 0;
        const countText = (dataCount === 1) ? this.translate('machine') : this.translate('machines');
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectMachine')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchMachinesOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={tableColumns}
                            rows={tableRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default MachinesOverviewContainer;
